module.exports = __webpack_public_path__ + "img/cbr2rr1.d16a6bd4.gif";